<template>
  <div class="settings-block">
    <div class="settings-block__title">
      <div class="settings-block__title-text mr-8">{{ t('Payment Method') }}</div>
      <div class="settings-block__title-buttons">
        <ui-button
          :text="t('Billing Info')"
          icon="fas fa-info"
          button-style="outline-accent"
          @click="openBilling"
        />

        <ui-button
          :text="t('Update Payment Method')"
          icon="fas fa-credit-card"
          button-style="outline-accent"
          @click="openPayment"
        />
      </div>
    </div>
    <div>
      <div v-if="customer.paymentMethod" class="paymentMethod-wrp pt-16 pb-8">
        <div class="payment-card_img pb-8">
          <img
            v-if="
              customer.paymentMethod.card && customer.paymentMethod.card.brand === 'visa'
            "
            height="45"
            src="/images/payment/visa.svg"
          />
          <img
            v-if="
              customer.paymentMethod.card &&
              customer.paymentMethod.card.brand === 'mastercard'
            "
            height="45"
            src="/images/payment/mastercard.svg"
          />
          <img
            v-if="
              customer.paymentMethod.card &&
              customer.paymentMethod.card.brand === 'diners_club'
            "
            height="45"
            src="/images/payment/diners_club.svg"
          />
          <img
            v-if="
              customer.paymentMethod.card &&
              customer.paymentMethod.card.brand === 'discover'
            "
            height="45"
            src="/images/payment/discover.svg"
          />
          <img
            v-if="
              customer.paymentMethod.card && customer.paymentMethod.card.brand === 'jcb'
            "
            height="45"
            src="/images/payment/jcb.svg"
          />
          <img
            v-if="
              customer.paymentMethod.card &&
              customer.paymentMethod.card.brand === 'american_express'
            "
            height="45"
            src="/images/payment/american_express.svg"
          />
        </div>
        <div class="payment-card_info" v-if="customer.paymentMethod.type === 'card'">
          <div class="payment_card pb-4">
            **** **** **** {{ customer.paymentMethod.card?.last4 }}
          </div>
          <div class="payment_expires">
            {{ t('Expires:') }}
            {{ customer.paymentMethod.card?.expiryMonth }}/{{
              customer.paymentMethod.card?.expiryYear
            }}
          </div>
        </div>
      </div>
      <div
        v-if="!customer.paymentMethod"
        align-center
        justify-center
        column
        fill-height
        class="pt-16 pb-8"
      >
        <div class="payment_card pb-4">
          {{ t('No payment method provided') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@/composables';
import { $emitter } from '@/services/emitter';
import { useStore } from '@/store';
import type { BillingCustomerState } from '@/services/models';

const store = useStore();
const { t } = useI18n();

const customer = computed((): BillingCustomerState => store.billingCustomer ?? {});

const openPayment = () => {
  $emitter.emit('open-dialog', { name: 'UpdatePaymentMethodDialog' });
};

const openBilling = () => {
  $emitter.emit('open-dialog', { name: 'UpdateBillingInfoDialog' });
};
</script>

<style lang="scss" scoped>
.settings-block__title {
  row-gap: 16px;
}

.paymentMethod-wrp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .payment-card_img {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .payment-card_info {
    text-align: center;
  }
}
</style>

<style lang="scss">
.payment-method {
  .payment_expires,
  .payment_card {
    font-weight: 600;
    font-size: 13px;
    color: var(--color-graphite);
  }

  .update-btn-ml {
    margin-right: 8px !important;
  }
}
</style>
